import { useQuery } from '@tanstack/react-query';

import { getRecentFeaturedListings, getShowcaseFeatures, getTestimonials } from './sell-your-car.api';

import { ApiFnReturnType } from '@/slw/shared/query-client';

export const useRecentFeaturedListings = () =>
  useQuery<ApiFnReturnType<typeof getRecentFeaturedListings>>({
    queryKey: ['recent-featured-listings'],
    queryFn: () => getRecentFeaturedListings(),
  });

export const useShowcaseFeatures = () =>
  useQuery<ApiFnReturnType<typeof getShowcaseFeatures>>({
    queryKey: ['showcase-features'],
    queryFn: getShowcaseFeatures,
  });

export const useTestimonials = () =>
  useQuery<ApiFnReturnType<typeof getTestimonials>>({
    queryKey: ['testimonials'],
    queryFn: getTestimonials,
  });
